<template>
  <div class="counter">
    <span class="grid-hide"></span>
    <div class="counter__container">
      <span class="counter__big">
        0{{ $store.state.currentGame.questionsIndex + 1 }}
      </span>
      <span class="counter__small">
        /0{{ $store.state.currentGame.questionsIdList.length }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameCounter',
};
</script>

<style lang="scss" scoped>
.counter {
  position: relative;
  display: block;
  width: calc((var(--unit-vw) * 2) - 2px);
  flex: 0 0 calc((var(--unit-vw) * 2) - 2px);
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  &__container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  &__big {
    position: relative;
    @extend %font-size-xxl;
  }

  &__small {
    position: relative;
    align-self: flex-start;
    margin-top: 2px;

    @include mq(ipadP) {
      margin-top: 1.2rem;
    }
  }

  @include mq($until: ipadP) {
    left: calc(var(--unit-vw) * 1);
  }
}
</style>
